import { render, staticRenderFns } from "./StoryWorktable copy.vue?vue&type=template&id=31b067f4&scoped=true"
import script from "./StoryWorktable copy.vue?vue&type=script&lang=js"
export * from "./StoryWorktable copy.vue?vue&type=script&lang=js"
import style0 from "./StoryWorktable copy.vue?vue&type=style&index=0&id=31b067f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b067f4",
  null
  
)

export default component.exports